import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const voidShipmentRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/shipments/:id/void',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/shipments/:id/void' \\
--header 'Authorization: Bearer <TOKEN>' \\
--header 'Content-Type: application/json'
`,
};

const voidShipmentResponse: Json = {
    title: 'RESPONSE',
    json: {
        "id": 89,
        "number": "S10005",
        "order": {
            "id": 2,
            "number": "10005",
            "type": "SO"
        },
        "carrier": {
            "id": 4,
            "name": "Fedex",
            "service": {
                "id": 10,
                "name": "Standard Overnight"
            }
        },
        "fobPointName": "Origin",
        "locationGroup": {
            "id": 5,
            "name": "SLC"
        },
        "lastModified": {
            "dateLastModified": "2026-03-11T23:31:27.234+00:00"
        },
        "dateCreated": "2026-03-11T23:27:50.211+00:00",
        "note": "",
        "contact": "Captain Kirk",
        "email": "elcapitan@example.com",
        "phone": "801-932-1101",
        "billOfLading": "00000000000000895",
        "shipToAddress": {
            "name": "Captain Kirk",
            "street": "17 Enterprise Way",
            "city": "Tanner",
            "state": "ND",
            "postalCode": "25897",
            "country": "UNITED STATES"
        },
        "status": "Entered",
        "cartons": [
            {
                "id": 89,
                "cartonNumber": 1,
                "trackingNumber": "",
                "freightWeight": "0",
                "freightWeightUom": {
                    "id": 3,
                    "name": "Pound",
                    "abbreviation": "lbs"
                },
                "freightAmount": "0",
                "sscc": "100000000000000892",
                "dateCreated": "2026-03-11T23:27:50.211+00:00",
                "width": "0",
                "height": "0",
                "length": "0",
                "sizeUom": {
                    "id": 7,
                    "name": "Inch",
                    "abbreviation": "in"
                },
                "insuredValue": "0",
                "shipperRelease": false,
                "additionalHandling": false,
                "shipItems": [
                    {
                        "id": 186,
                        "orderItemId": 3,
                        "product": {
                            "id": 79,
                            "name": "H100",
                            "description": "Basic Bike Helmet"
                        },
                        "tagNumber": "591",
                        "quantity": "1",
                        "uom": {
                            "id": 1,
                            "name": "Each",
                            "abbreviation": "ea"
                        },
                        "totalCost": "0"
                    }
                ]
            }
        ],
        "customFields": [
            {
                "id": 21,
                "name": "Custom",
                "value": "",
                "type": "Text"
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'void-shipment',
    title: 'Void a shipment',
    description: 'Voids a shipment in "Packed" or "Shipped" status, reverting it back to "Entered". Packed shipments are reset to "Entered". Shipped shipments perform the existing rollback flow, which can restore inventory and remove unposted accounting data when supported. Returns a 400 error when the shipment cannot be voided.',
    endpoint: {
        verb: 'POST',
        path: '/shipments/:id/void',
        tooltip: 'Void a shipment',
    },
    attributes: [],
    requestObject: voidShipmentRequest,
    responseObject: voidShipmentResponse,
};

export default data;
